<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpen"
    class="custom"
    target="#search-activator"
    location="bottom end"
    :offset="6"
    @update:model-value="onMenuToggle"
  >
    <v-list class="notification custom-height pa-0">
      <v-card density="compact" flat min-width="100%" class="pa-0 search-card">
        <v-card-text density="compact" class="pa-0 ma-0">
          <v-row no-gutters dense class="pa-1">
            <!-- Search Box, Mode Badge and Close Button inside this screen -->
            <v-col cols="12" class="px-3 pt-3 pb-1">
              <div class="tn-search-head">
                <!-- Search mode indicator on the left side of search box -->
                <div
                  class="tn-search-mode-tag"
                  :class="subject == true ? 'tn-search-mode-tag--subject' : 'tn-search-mode-tag--ref'"
                  :title="subject == true ? 'Searching by Subject' : 'Searching by Reference Number'"
                >
                  <span>{{ subject == true ? 'Subject' : 'Ref Num' }}</span>
                </div>

                <div class="tn-search-field-box">
                  <TextFieldComponent
                    style="caret-color: auto;"
                    clearable
                    hide-details
                    :close-on-content-click="false"
                    ref="searchIssue"
                    v-model="searchQuery"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="subject == true ? 'Search Subject...' : 'Search Reference Number...'"
                    @input="getSearch"
                    :loader="searchLoader"
                  />
                </div>
                <button class="tn-search-close-btn" @click="closeMenu" type="button" title="Close search">
                  <v-icon size="18" color="#64748b">mdi-close</v-icon>
                </button>
              </div>
            </v-col>

            <!-- Section Title -->
            <v-col cols="12" class="px-3 pt-2 pb-1 font-weight-bold tn-search-title">
              {{ searchQuery && searchQuery.length > 0 ? "Searched Result" : "Recently created Tasks" }}
            </v-col>

            <!-- Loader -->
            <v-col cols="12" v-if="loading" class="loader my-4">
              <v-progress-circular
                indeterminate
                color="primary"
                size="36"
                width="3"
              ></v-progress-circular>
            </v-col>

            <!-- Issues List -->
            <v-col cols="12" class="py-1" v-else>
              <v-list density="compact" class="pa-0 bg-transparent">
                <div v-if="issues && issues.length > 0">
                  <v-list-item
                    density="compact"
                    link
                    v-for="item in issues"
                    :key="item.id || item.issue_id || item"
                    class="list-item-bc py-1 px-3"
                    @click="openIssue(item)"
                  >
                    <template v-slot:prepend>
                      <CustomAvatar2
                        :size="'medium'"
                        :fName="item.first_Name || item.first_name"
                        :lName="item.last_Name || item.last_name"
                        :theme="item.theme"
                        :imgUrl="item.n_image_url ? item.n_image_url : null"
                      />
                    </template>
                    <v-list-item-title class="tn-issue-title">
                      &nbsp;{{ item && item.reference_num ? item.reference_num : "" }} - {{ item && item.name ? item.name : '' }}
                    </v-list-item-title>
                    <template v-slot:append>
                      <v-chip v-if="item.stage" class="onText3" label size="small">
                        <b>{{ item.stage ? getStage(item.stage) : "" }}</b>
                      </v-chip>
                    </template>
                  </v-list-item>
                </div>
                <div v-else class="py-6 text-center">
                  <v-img :src="require('@/assets/no-record.png')" style="width:200px; height:140px; margin: 0 auto;" />
                  <p class="mt-2 text-center text-caption text-medium-emphasis">No Data Found</p>
                </div>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-list>
  </v-menu>
</template>

<script>
import TextFieldComponent from '../TextFieldComponent.vue';
import IssueService from "@/api/service/Issue/IssueService";
import ApiService from "@/api/service/apiServiceIssue.js";
import EnumService from "@/api/service/Enum/EnumService";
import CustomAvatar2 from './CustomAvatar2.vue';

export default {
  props: ['subject'],
  emits: ['close'],
  components: {
    TextFieldComponent,
    CustomAvatar2
  },

  data() {
    return {
      menuOpen: true,
      page: 0,
      loading: false,
      searchLoader: false,
      searchQuery: '',
      issues: [],
      elseIssue: [],
      backUpIssue: [],
      stageData: [],
    };
  },

  watch: {
    searchQuery(newVal) {
      if (!newVal || newVal.trim() === '') {
        this.issues = this.elseIssue;
      }
    }
  },

  mounted() {
    this.getStageData();
    this.getIssueList();
    this.focusInput();
  },

  methods: {
    closeMenu() {
      this.menuOpen = false;
      this.$emit('close');
    },

    onMenuToggle(val) {
      if (!val) {
        this.closeMenu();
      }
    },

    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.searchIssue && this.$refs.searchIssue.$el) {
          const input = this.$refs.searchIssue.$el.querySelector('input');
          if (input) input.focus();
        }
      });
    },

    getSearch() {
      if (this.searchQuery && this.searchQuery.trim().length > 0) {
        let $issues = this.searchFilter();
        if ($issues.length === 0) {
          this.searchLoader = true;
          this.getMoreIssues();
        } else {
          this.issues = $issues;
        }
      } else {
        this.issues = this.elseIssue;
      }
    },

    searchFilter() {
      let q = (this.searchQuery || '').trim().toLowerCase();
      if (!q) return this.elseIssue;
      return this.backUpIssue.filter(ele => {
        if (!ele) return false;
        if (this.subject === true) {
          return ele.name && ele.name.toLowerCase().includes(q);
        } else {
          return (
            (ele.reference_num && ele.reference_num.toLowerCase().includes(q)) ||
            (ele.name && ele.name.toLowerCase().includes(q))
          );
        }
      });
    },

    async getMoreIssues() {
      let queryText = (this.searchQuery || '').trim();
      if (!queryText) {
        this.issues = this.elseIssue;
        this.loading = false;
        this.searchLoader = false;
        return;
      }
      try {
        this.loading = true;
        let params = this.subject === true
          ? { subject: queryText, page: this.page }
          : { reference_num: queryText, page: this.page };

        const timeoutPromise = new Promise((resolve) =>
          setTimeout(() => resolve([]), 4000)
        );
        let res = await Promise.race([IssueService.getOneUserIssue(params), timeoutPromise]);
        this.issues = Array.isArray(res) ? res : [];
      } catch (error) {
        console.log("getMoreIssues error:", error);
        this.issues = [];
      } finally {
        this.loading = false;
        this.searchLoader = false;
      }
    },

    async getIssueList() {
      try {
        this.loading = true;
        // Fetch recently created tasks from getOneUserIssue endpoint
        const fetchPromise = ApiService.request({ url: 'getOneUserIssue', method: 'get' });
        const timeoutPromise = new Promise((resolve) =>
          setTimeout(() => resolve({ data: { data: [] } }), 4000)
        );
        let response = await Promise.race([fetchPromise, timeoutPromise]);
        let res = response && response.data ? response.data.data : null;
        if (res && Array.isArray(res)) {
          this.elseIssue = res.slice(0, 15);
          this.backUpIssue = [...res];
          this.issues = this.elseIssue;
        } else {
          this.elseIssue = [];
          this.backUpIssue = [];
          this.issues = [];
        }
      } catch (e) {
        console.log("getIssueList error:", e);
        this.elseIssue = [];
        this.backUpIssue = [];
        this.issues = [];
      } finally {
        this.loading = false;
      }
    },

    async getStageData() {
      try {
        let res = await EnumService.findAllDomain({ domain: 'STAGE' });
        this.stageData = res && res.length > 0 ? res : [];
      } catch (e) {
        this.stageData = [];
      }
    },

    getStage(value) {
      if (!this.stageData || !this.stageData.length) return "";
      let opt = this.stageData.filter(k => k.data_value == value);
      return opt && opt.length > 0 ? opt[0].display_value : "";
    },

    openIssue(data) {
      if (!data) return;
      const issueId = data.id || data.issue_id;
      if (!issueId) return;

      let obj = {
        workspace: {
          id: data.work_space_id,
          name: data.work_space_name
        },
        project: {
          id: data.project_id,
          name: data.project_name
        },
        account: {
          id: data.account_id,
          name: data.account_name
        }
      };
      localStorage.setItem('_WS_DEFAULTS_', JSON.stringify(obj));
      if (data.work_space_id) {
        localStorage.setItem("workSpaceId", data.work_space_id);
      }
      this.$store.commit("SET_REFRESH_BREADCRUMP", true);

      // Force drawer reset and open
      this.$store.commit("SET_ISSUE_VIEW_DRAWER", false);
      this.$store.commit("SET_DEFAULT_ISSUE_IN_VIEW", null);

      if (this.$route && this.$route.path && this.$route.path.includes('issueView2')) {
        this.$router.push({ path: '/issueView2', query: { id: issueId, type: 'view' } });
      }

      setTimeout(() => {
        this.$store.dispatch("setIssueInView", issueId);
        this.closeMenu();
      }, 50);
    }
  }
};
</script>

<style scoped>
.tn-search-head {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.tn-search-mode-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding: 0 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  flex-shrink: 0;
  gap: 4px;
}

.tn-search-mode-tag--subject {
  background: #f0f9ff;
  border: 1.5px solid #bae6fd;
  color: #0369a1;
}

.tn-search-mode-tag--ref {
  background: #eef2ff;
  border: 1.5px solid #c7d2fe;
  color: #3730a3;
}

.tn-search-field-box {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.tn-search-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.tn-search-close-btn:hover {
  background-color: #fee2e2;
  border-color: #fca5a5;
}

.tn-search-close-btn:hover .v-icon {
  color: #ef4444 !important;
}

.tn-search-title {
  color: #1e293b;
  font-size: 13.5px;
}

.tn-issue-title {
  font-size: 13.5px;
  color: #1e293b;
}

.list-item-bc {
  cursor: pointer !important;
  border-radius: 6px !important;
  margin: 1px 4px !important;
  transition: background-color 0.15s ease !important;
}

.list-item-bc:hover {
  background-color: #f1f5f9 !important;
}

.loader {
  height: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-card {
  min-height: 100% !important;
  background-color: #ffffff !important;
}

.onText3 {
  font-size: 11px;
  font-weight: 600;
  text-align: start;
  background: #d6f8f6;
  color: #0f766e;
}

/* Default height and spotlight styling */
:deep(.notification),
>>>.notification {
  height: 520px !important;
  max-height: 85vh !important;
  width: 640px !important;
  max-width: 92vw !important;
  border-radius: 8px !important;
  box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.18) !important;
  overflow-y: auto !important;
  background-color: #ffffff !important;
}

:deep(.notification .v-input),
>>>.notification .v-input {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

:deep(.notification .v-input__details),
>>>.notification .v-input__details {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 0 !important;
  min-height: 0 !important;
}

:deep(.notification .v-input__control),
>>>.notification .v-input__control {
  min-height: 38px !important;
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
}

/* Search Box design with visible background and border */
:deep(.notification .v-field),
>>>.notification .v-field {
  height: 38px !important;
  min-height: 38px !important;
  border-radius: 8px !important;
  background-color: #f1f5f9 !important;
  border: 1.5px solid #cbd5e1 !important;
  padding: 0 8px 0 10px !important;
  display: flex !important;
  align-items: center !important;
  box-shadow: none !important;
  width: 100% !important;
  transition: all 0.2s ease !important;
}

:deep(.notification .v-field--focused),
>>>.notification .v-field--focused {
  background-color: #ffffff !important;
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
}

:deep(.notification .v-field__outline),
>>>.notification .v-field__outline {
  display: none !important;
}

:deep(.notification .v-field__field),
>>>.notification .v-field__field {
  height: 38px !important;
  min-height: 38px !important;
  display: flex !important;
  align-items: center !important;
}

:deep(.notification .v-field__field .v-field__input),
>>>.notification .v-field__field .v-field__input {
  background: transparent !important;
  background-color: transparent !important;
  font-size: 13.5px !important;
  color: #1e293b !important;
  padding: 0 8px !important;
  height: 38px !important;
  min-height: 38px !important;
  line-height: 38px !important;
  display: flex !important;
  align-items: center !important;
  border-radius: 8px !important;
  width: 100% !important;
}

:deep(.notification .v-field__field .v-field__input:focus-within),
>>>.notification .v-field__field .v-field__input:focus-within {
  width: 100% !important;
  background-color: transparent !important;
}

:deep(.notification .v-field__prepend-inner),
>>>.notification .v-field__prepend-inner {
  padding-top: 0 !important;
  align-items: center !important;
  height: 38px !important;
  margin-right: 2px !important;
}

:deep(.notification .v-field__prepend-inner .v-icon),
>>>.notification .v-field__prepend-inner .v-icon {
  color: #64748b !important;
  font-size: 18px !important;
}

:deep(.notification .v-field__append-inner),
>>>.notification .v-field__append-inner {
  padding-top: 0 !important;
  align-items: center !important;
  height: 38px !important;
}

:deep(.notification .v-field__clearable),
>>>.notification .v-field__clearable {
  padding-top: 0 !important;
  align-items: center !important;
  height: 38px !important;
  margin-right: 2px !important;
}

:deep(.notification .v-field__clearable .v-icon),
>>>.notification .v-field__clearable .v-icon {
  font-size: 16px !important;
  color: #94a3b8 !important;
}
</style>